import PropTypes from "prop-types";
import { useMemo } from "react";
import { useFilters, useSortBy, useTable } from "react-table";

import { Table, WrapperContainer } from "../../../../components";
import { MarketFeaturesModalTableColumns } from "./MarketFeaturesModalTableColumns";

const MarketFeaturesModalTable = ({ features, onToggleValue }) => {
  const columns = useMemo(() => MarketFeaturesModalTableColumns, []);
  const tableInstance = useTable(
    {
      columns,
      data: features,
      initialState: {
        sortBy: [
          {
            id: "settingName",
            asc: true
          }
        ]
      }
    },
    useFilters,
    useSortBy
  );

  return (
    <WrapperContainer mb={24} width={730}>
      <Table
        tableInstance={tableInstance}
        componentHeight={features.length ? 0 : 64}
        maxTableHeight="108px"
        modalTable
        callbackFn1={onToggleValue}
        maxVisibleRows={1}
        showTableBorder
      />
    </WrapperContainer>
  );
};

MarketFeaturesModalTable.propTypes = {
  features: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      settingName: PropTypes.string.isRequired,
      value: PropTypes.bool.isRequired
    })
  ).isRequired,
  onToggleValue: PropTypes.func.isRequired
};

export default MarketFeaturesModalTable;
